import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useAuthState } from "../../../../../Helper/Context";
import { WorkAssignByOfficialsAPI } from "../../../../../Redux/WorkAssignByOfficialsSlice/WorkAssignByOfficialsSlice";
import moment from "moment";
import { Loading } from "../../../../../Helper/Loading";
import { ExportGardenReopenCardManageN } from "./ExportGardenReopenCardManageN";

export const GardenReopenCardManageN = (props) => {
    const { Month, FinancialYear, AssetID, ActiveBtn } = props
    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [OpenModal, setOpenModal] = useState(false);
    const [Flag, setFlag] = useState("");
    const [officerData, setOfficerData] = useState(null)
    const [weekID, setWeekID] = useState(0)
    const [Isclear, setIsClear] = useState(false)

    const handlePopupOpen = (data, week, type, desig) => {
        if (data && type === "VisitTarget" && desig === "Garden  Assistant") {
            setOfficerData(data)
            setWeekID(week)
            setFlag("VisitTarget")
            setOpenModal(true);
        }
        if (data && type === "Achievement") {
            setOfficerData(data)
            setWeekID(week)
            setFlag("Achievement")
            setOpenModal(true);
        }

        // if (data && type === "Pending" && desig === "Garden  Assistant") {
        //   setOfficerData(data)  
        //   setWeekID(week)
        //   setFlag("Pending")
        //   setOpenModal(true);
        // }

    };

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const Tabledata = [
        {


            "Heading": [
                // {
                //     "head": "Designation",
                // },
                {
                    "head": "Contractor Name  ",
                },
                {
                    "head": "Ward",
                },
                {
                    "head": "Total Assign Works",
                },
                {
                    "head": "Total works Completed",
                },
                {
                    "head": "Total pending works",
                },
                {
                    "head": "0 to 7 days",
                },
                {
                    "head": "7 to 15 days",
                },
                // {
                //     "head": "Completed",
                // },
                {
                    "head": "15 to 30 days",
                },
                {
                    "head": "30 to 90 days",
                },
                {
                    "head": "90 to 180 days",
                },
                {
                    "head": "1 year",
                },


            ],

        }
    ]

    const [fromDate, setFromDate] = useState("")
    const [toDate, setToDate] = useState("")

    const handleClear = () => {
        setIsClear(!Isclear)
        setFromDate("")
        setToDate('')
    }
    useEffect(() => {
        const data = {
            FromDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : "",
            ToDate: toDate ? moment(toDate).format('YYYY-MM-DD') : "",
            M_WorkTypeID: 0,
            M_ZoneID: 0,
            M_WardID: 0,
            M_AssetTypeID: AssetID,
            M_WorkTypeID: 0,
            M_UserID: UserID,
            Flag: "ReopenContractor",
            token: token,

        }
        dispatch(WorkAssignByOfficialsAPI({ data }))
    }, [fromDate, toDate, Isclear])

    const { tableData, isLoading } = useSelector(state => state.Get_WEB_GD_OfficerWisePendingWorkStatus_SelectData)



    return (
        <>
            {isLoading && <Loading />}
            <div className='row m-0 p-0 pt-2  bg-white' style={{ border: '1px solid #0d467ee6', borderRadius: '8px ', width: '100%', overflow: 'scroll' }}>

                <div className="col-12 col-lg-6 ps-lg-4">

                    <div className="row">
                        <div className="col-12 col-lg-6">
                            <label className="d-block" htmlFor="fromDate"><b>From Date : </b></label>
                            <input type="date" className="form-control" id="fromDate" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                        </div>
                        <div className="col-12 col-lg-6">
                            <label className="d-block" htmlFor="toDate"><b>To Date : </b></label>
                            <input type="date" className="form-control" id="toDate" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                        </div>
                    </div>

                </div>

                <div className="col-12 col-lg-6 d-flex align-items-end ">
                    <div className="">
                        <button onClick={handleClear} type="button" className="btn active_group_btn mr-1  ml-1 px-3" > Clear</button>
                        {/* <button type="button" className="btn text-white mr-1  ml-1" style={{ background: '#048a8b' }}> Export</button> */}
                        <ExportGardenReopenCardManageN
                            tableData={tableData}
                            name={ActiveBtn}
                            Tabledata={Tabledata}
                            fromDate={fromDate}
                            toDate={toDate}
                        />
                    </div>
                </div>


                <div className="col-12 pt-3 pb-0 m-1">
                    <table id="totalordergenerated"
                        cellPadding="0"
                        cellSpacing="0"
                        border="0"
                        className="table table-bordered " style={{ textAlign: "center" }}>
                        <thead className="gardenworktable" id="customers">

                            {/* <tr className="text-center ">
                                <th colSpan={20} className="text-center fw-bold fs-6" style={{ background: '#254462' }}>Garden Work Daily Checklist Progress</th>
                            </tr> */}

                            {/* <tr className="text-center tablethhead">
                                {
                                    Tabledata && Tabledata[0]?.MainHeading.map((i) => {
                                        return (
                                            <th colSpan={i.no} className="text-center fw-bold fs-6" id="tablecolor">{i.manihead}</th>

                                        )
                                    })
                                }
                            </tr> */}

                            <tr className="text-center tablethhead " style={{ width: '100%' }}>
                                {
                                    Tabledata && Tabledata[0]?.Heading.map((j) => {

                                        return (
                                            <th className="text-center fw-bold  py-2" style={{ whiteSpace: 'nowrap' }}>{j.head}</th>
                                        )
                                    })
                                }
                            </tr>

                        </thead>
                        <tbody>
                            {/* {Tabledata[0]?.Tabledata?.map((designation) => {
                                return designation.Rowdata?.map((officer, officerIndex) => {
                                    const rowSpan = designation.Rowdata?.length || 1;
                                    return (
                                        <tr className="text-center" key={`${designation.designationName}-${officerIndex}`}>

                                            {officerIndex === 0 ? (
                                                <td rowSpan={rowSpan}>{designation.designationName}</td>
                                            ) : null}

                                            <td>{officer.officename}</td>
                                            <td>{officer.Zone}</td>
                                            <td>{officer.VisitTargetWeek1}</td>
                                            <td>{officer.AchievementWeek1}</td>
                                            <td>{officer.PendingWeek1}</td>
                                            <td>{officer.VisitTargetWeek2}</td>
                                            <td>{officer.AchievementWeek2}</td>
                                            <td>{officer.PendingWeek2}</td>
                                            <td>{officer.VisitTargetWeek3}</td>
                                            <td>{officer.AchievementWeek3}</td>
                                            <td>{officer.PendingWeek3}</td>
                                        </tr>
                                    );
                                });
                            })} */}

                            {tableData?.map((designation) => {
                                return designation.rowdata?.map((officer, officerIndex) => {
                                    const rowSpan = designation.rowdata?.length || 1;
                                    return (
                                        <tr
                                            className="text-center"
                                            key={`${designation.designation}-${officerIndex}`}
                                        >
                                            {/* {officerIndex === 0 ? (
                                                <td className="text-center" rowSpan={rowSpan}>{designation.designation}</td>
                                            ) : null} */}

                                            <td style={{ whiteSpace: "nowrap" }}>{officer.employeeName}</td>
                                            <td>{officer.wardName}</td>
                                            <td  onClick={() => handlePopupOpen(officer, 1, "VisitTarget", designation.designationName)} className="bluecolorCount text-center">{officer.totalAllCount}</td>
                                            <td  onClick={() => handlePopupOpen(officer, 1, "Achievement")} className="greencolorCount text-center">{officer.completedCount}</td>
                                            <td  onClick={() => handlePopupOpen(officer, 1, "Pending", designation.designationName)} className="orangecolorCount text-center">{officer.pendingCount}</td>
                                            <td  onClick={() => handlePopupOpen(officer, 2, "VisitTarget", designation.designationName)} className="bluecolorCount text-center">{officer.pending_0_7DaysCount}</td>
                                            <td  onClick={() => handlePopupOpen(officer, 2, "Achievement")} className="greencolorCount text-center">{officer.pending_7_15DaysCount}</td>
                                            <td  onClick={() => handlePopupOpen(officer, 2, "Pending", designation.designationName)} className="orangecolorCount text-center">{officer.pending_15_30DaysCount}</td>
                                            <td  onClick={() => handlePopupOpen(officer, 3, "VisitTarget", designation.designationName)} className="bluecolorCount text-center">{officer.pending_30_90DaysCount}</td>
                                            <td  onClick={() => handlePopupOpen(officer, 3, "Achievement")} className="greencolorCount text-center">{officer.pending_90_180DaysCount}</td>
                                            <td  onClick={() => handlePopupOpen(officer, 3, "Pending", designation.designationName)} className="orangecolorCount text-center">{officer.pending_365DaysCount}</td>

                                        </tr>
                                    );
                                });
                            })}


                        </tbody>
                    </table>
                </div>
            </div>
            {/* {
                OpenModal &&
                <VisitAchievePendingModal
                    handleOpenModal={handleOpenModal}
                    Title={Flag}
                    Flag={Flag}
                />
            } */}
        </>
    )
}